/**
 * "N pedidos esperando você" (PO, 22/09/2026) — o mesmo lugar e o mesmo peso
 * do convite de família: quem decide precisa saber sem ir procurar. Some
 * sozinho quando não há pedido (ou quando quem olha não decide: a API
 * devolve zero).
 */
import { useNavigate } from 'react-router-dom';

import { useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { usePedidosDeSugestao } from './api';

export function PedidosDeSugestaoNaHome() {
  const { tripId } = useTrip();
  const navigate = useNavigate();
  const pedidos = usePedidosDeSugestao(tripId);
  const n = pedidos.data?.pending ?? 0;
  if (n === 0) return null;
  return (
    <button type="button" className="home-alerta home-alerta--sugestao" onClick={() => navigate('/sugestoes')} data-testid="home-alerta-sugestoes">
      <span className="home-alerta__icone" aria-hidden="true"><Icon name="externo" size={18} /></span>
      <span className="home-alerta__texto">
        {n === 1 ? (
          <>
            <b>1 sugestão</b> quer entrar no roteiro. Toque para decidir.
          </>
        ) : (
          <>
            <b>{n} sugestões</b> querem entrar no roteiro. Toque para decidir.
          </>
        )}
      </span>
      <Icon name="avancar" size={16} />
    </button>
  );
}
